export default __webpack_public_path__ + "static/hq-f2e4920af9ce5fd0894edf7dcff36e2b.png";